<template>
  <div>
      <Panel header="Plano" class="p-mt-3 p-mb-3"> 
        <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-12">
                <label for="plano">Plano</label>
                <Dropdown id="plano" v-model="planoRef" :options="planos" optionLabel="nome" @change="selecionar"/>			                            
            </div>										
        </div>  
        <div class="p-mb-3">
            <Button label="Editar Perfil" icon="pi pi-pencil" @click="exibirDialogPerfilPlano=true"/>
            <Button label="Editar Benefícios" class="p-ml-2" icon="pi pi-pencil" @click="exibirDialogBeneficioPlano=true"/>
        </div>             
        <Panel header="Detalhes">
            <div class="p-fluid p-formgrid p-grid"> 
                <div class="p-field p-col-12 p-md-6">
                    <label for="nome">Nome</label>
                    <InputText id="nome" v-model.trim="planoSelecionado.nome" autocomplete="off" maxlength="100"/> 
                    <small class="p-invalid" v-if="enviandoForm && !planoSelecionado.nome">Informe o nome do plano</small>
                </div> 
                <div class="p-field p-col-12 p-md-2">
                    <label for="quantidadePessoas">Qtd. Pessoas</label>
                    <InputNumber id="quantidadePessoas" v-model.number="planoSelecionado.quantidadePessoas" 
                        :useGrouping="false" autocomplete="off" maxlength="15" class="p-text-right"/>
                    <small class="p-invalid" v-if="enviandoForm && !planoSelecionado.quantidadePessoas">Informe o limite de Pessoas</small>
                </div>
                <div class="p-field p-col-12 p-md-2">
                    <label for="quantidadeUsuarios">Qtd. de Usuários</label>
                    <InputNumber id="quantidadeUsuarios" type="text" v-model.number="planoSelecionado.quantidadeUsuarios" 
                        :useGrouping="false" autocomplete="off" maxlength="15" class="p-text-right"/>                       
                </div>
                <div class="p-field p-col-12 p-md-2">
                    <label>Qtd. de CNPJs</label>
                    <InputNumber type="text" v-model.number="planoSelecionado.quantidadeCNPJs" 
                        :useGrouping="false" autocomplete="off" maxlength="15" class="p-text-right"/>                                     
                </div>
                <div class="p-field p-col-12 p-md-2">
                    <label>Qtd. de Usuários App</label>
                    <InputNumber type="text" v-model.number="planoSelecionado.quantidadeUsuariosApp" 
                        :useGrouping="false" autocomplete="off" maxlength="15" class="p-text-right"/>                                               
                </div> 
                <div class="p-field p-col-12 p-md-2">
                    <label>Qtd. de Usuários Web</label>
                    <InputNumber type="text" v-model.number="planoSelecionado.quantidadeUsuariosWeb" 
                        :useGrouping="false" autocomplete="off" maxlength="15" class="p-text-right"/>                                               
                </div>                
                <div class="p-field p-col-12 p-md-2" v-if="planoSelecionado.tipoPagamento == 1">
                    <label for="valorMensal">Pagamento Mensal</label>
                    <InputNumber v-model.number="planoSelecionado.valorMensal" currency="BRL" 
                        locale="pt-BR" autocomplete="off" maxlength="15" class="p-text-right" id="valorMensal"/>
                    <small class="p-invalid" v-if="enviandoForm && !planoSelecionado.valorMensal">Informe o valor</small>                              
                </div>
                <div class="p-field p-col-12 p-md-2" v-if="planoSelecionado.tipoPagamento == 2">
                    <label for="valorAnual">Pagamento Anual</label>
                    <InputNumber v-model.number="planoSelecionado.valorAnual" currency="BRL" 
                        locale="pt-BR" autocomplete="off" maxlength="15" class="p-text-right" id="valorAnual"/>
                    <small class="p-invalid" v-if="enviandoForm && !planoSelecionado.valorAnual">Informe o valor</small>                         
                </div>
                <div class="p-field p-col-12 p-md-2">
                     <label for="valor">Pagamento</label>
                    <SelectButton v-model="planoSelecionado.tipoPagamento" :options="tiposPagamentos" optionLabel="nome" optionValue="valor"/>
                </div> 
                <div class="p-field p-col-12 p-md-2">
                    <label class="p-invalid p-text-bold" v-if="planoSelecionado.validade == 'Teste'">Validade</label>
                    <label v-if="planoSelecionado.validade == 'Producao'">Validade</label>
                    <InputText value="Produção" v-if="planoSelecionado.validade == 'Producao'" readonly/>
                    <InputText value="Teste" v-if="planoSelecionado.validade == 'Teste'" class="p-invalid" readonly/>
                </div>
                <div class="p-field p-col-12 p-md-12">
                    <label>Complemento</label>
                    <Textarea v-model="complemento" rows="3" cols="12"/>
                </div>                           
            </div>  
        </Panel>
    </Panel>
    <Dialog :visible.sync="exibirDialogPerfilPlano" header="Perfil do Plano" :modal="true" :style="{width: '65vw'}">
        <FormPerfil :plano="planoSelecionado"/>
        <template #footer>
            <Button label="OK" icon="pi pi-check" @click="exibirDialogPerfilPlano=false"/>
        </template>
    </Dialog>
    <Dialog :visible.sync="exibirDialogBeneficioPlano" header="Benefícios do Plano" :modal="true" :style="{width: '50vw'}">
        <FormBeneficio :plano="planoSelecionado"/>
        <template #footer>
            <Button label="OK" icon="pi pi-check" @click="exibirDialogBeneficioPlano=false"/>
        </template>
    </Dialog>
  </div>
</template>

<script>

import Plano from '@/model/Plano';
import FormPerfil from '@/components/pages/cadastro/cliente/FormPerfil';
import FormBeneficio from '@/components/pages/cadastro/cliente/FormBeneficio';
import { clonar } from '@/global';

export default {
    data() {
        return {
            enviandoForm: false,
            exibirDialogBeneficioPlano: false,
            exibirDialogPerfilPlano: false,
            planoSelecionado: new Plano(),
            planoRef: null,
            planos: [],
            tiposPagamentos: [{nome: 'Mensal', valor: 1}, {nome: 'Anual', valor: 2}],
            complemento: '',
        }
    },
    methods: {
        carregar(planos) {
            if(planos.length) {                
                this.planoRef = planos[0];                
            } 
            this.planos = planos;;
            this.planoSelecionado = clonar(this.planoRef);           
        },
        selecionar() {
            this.planoSelecionado = clonar(this.planoRef);
        },      
        getPlano() {
            this.planoSelecionado.complemento = this.complemento;
            return this.planoSelecionado;
        },
        validarCampos(enviandoForm) {
            this.enviandoForm = enviandoForm;
        }
    },
    watch: {
        complemento: function(novo) {
            if(novo.length > 200) {
                this.complemento = novo.substring(0, 200);
            }
        }
    },
    components: {
        'FormPerfil': FormPerfil,
        'FormBeneficio': FormBeneficio,
    },
}
</script>

<style>

</style>